import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'

if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn
  console.warn = (...args) => {
    const message = args[0]
    if (
      typeof message === 'string' &&
      (message.includes('findDOMNode is deprecated') ||
        message.includes(
          'Support for defaultProps will be removed from function components'
        ) ||
        message.includes('FormRadio') ||
        message.includes('Radio') ||
        message.includes('FormCheckbox'))
    ) {
      return
    }
    originalWarn(...args)
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
